function getServerMessage (error) {
  if (!error || !error.response || !error.response.data) {
    return ''
  }

  const data = error.response.data
  if (typeof data === 'string') {
    return data
  }

  if (data.message) {
    return data.message
  }

  if (data.error && data.error.message) {
    return data.error.message
  }

  return ''
}

export function getGermanHttpErrorMessage (error, fallback = 'Die Anfrage konnte nicht verarbeitet werden.') {
  if (!error || !error.response) {
    return 'Die API ist nicht erreichbar. Bitte prüfen, ob das Backend läuft und die Server-URL korrekt ist.'
  }

  const status = Number(error.response.status || 0)

  if (status === 400) {
    return getServerMessage(error) || 'Die Anfrage ist unvollständig oder ungültig.'
  }

  if (status === 401) {
    return 'Die Anmeldung ist fehlgeschlagen. Bitte E-Mail-Adresse und Passwort prüfen.'
  }

  if (status === 403) {
    return 'Für diese Aktion fehlen die nötigen Berechtigungen.'
  }

  if (status === 404) {
    return 'Der angefragte Datensatz wurde nicht gefunden.'
  }

  if (status === 422) {
    return getServerMessage(error) || 'Bitte die Eingaben prüfen.'
  }

  if (status >= 500) {
    return 'Im Backend ist ein Fehler aufgetreten. Bitte später erneut versuchen oder die API-Logs prüfen.'
  }

  return getServerMessage(error) || fallback
}

export function getForgotPasswordErrorMessage (error) {
  if (error && error.response && error.response.status === 404) {
    return 'Zu dieser E-Mail-Adresse wurde kein Mitarbeiter gefunden.'
  }

  return getGermanHttpErrorMessage(error, 'Das neue Passwort konnte nicht angefordert werden.')
}
